<script setup>
import { computed, defineProps, ref, watch } from 'vue';

const props = defineProps({
	answers: {
		type: Array,
		required: true,
	},

	disabled: {
		type: Boolean,
		default: false,
	},

	response: {
		type: String,
		required: false,
	},

	groupName: {
		type: [String, Number],
		default: 'default',
	},
});

const answerSelected = ref(null);

watch(
	() => props.response,

	(response) => {
		answerSelected.value = response ?? null;
	},

	{ immediate: true }
);

const radioName = computed(() => `multiple-choice-${props.groupName}`);

const isSelected = (answer) => props.response === answer;
</script>

<template>
	<div class="flex flex-col gap-2">
		<div v-for="(answer, index) in props.answers" :key="index">
			<div class="flex items-center gap-2">
				<span
					v-if="props.disabled"
					class="mt-0.5 inline-flex h-4 w-4 flex-none shrink-0 items-center justify-center rounded-full border-2"
					:class="
						isSelected(answer)
							? 'border-yellow-600'
							: 'border-neutral-400'
					"
				>
					<span
						v-if="isSelected(answer)"
						class="h-2 w-2 shrink-0 rounded-full bg-yellow-600"
					/>
				</span>

				<input
					v-else
					v-model="answerSelected"
					:value="answer"
					:name="radioName"
					type="radio"
					class="mt-0.5 h-4 w-4 flex-none shrink-0 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
				/>

				<div class="min-w-0 flex-1 break-words text-sm text-neutral-600">
					{{ answer }}
				</div>
			</div>
		</div>
	</div>
</template>

